<template>
    
   <div class="mainmenu" >
    <div class="topnav" id="mainmenu">
        
      <a v-for="item in menus" :key="item.label" :href="item.link" v-bind:class="{ active:item.isactive }" >{{ item.label }}</a>
      <a href="#" @click="fnSwitchLang(fnGetNextLang())">{{ nextlang }}</a>
      <a href="javascript:void(0);" class="icon" @click="fnExpandMenu()">
        <i class="fa fa-bars"></i>
      </a>
    </div>
  </div>
 
</template>

<script>

import multilangmixin from "../mixins/multilangmixin.js"

////////// eslint-disable-next-line no-unused-vars


export default {
  name: "cmpnavigation",
  mixins:[multilangmixin],
    

  data(){
      return {
                "pages":["home","cosafacciamo","casestudies","esplorazioni","contatti"],
                "menus": []
            };
  },

  created(){

    //console.log("created ",this.$options.name, "   lingua: ",this.currentlang);
    this.fnFillMenu();

  },

  computed:{


      nextlang()
      {
        return this.fnGetTranslation(this.currentlang, this.fnGetNextLang());
      },

      isactive()
      {

        let wret="";

        if (window.location.pathname.length>=4)
        {
          if ((window.location.pathname[0]=="/") && (window.location.pathname[3]=="/"))
            {

              wret=window.location.pathname.substring(1,3);            
          }
        }

        return wret;
      },
      

  },


  methods:{


    fnExpandMenu() 
    {
        var x = document.getElementById("mainmenu");
        if (x.className === "topnav") 
        {
          x.className += " responsive";
        } 
        else 
        {
          x.className = "topnav";
        }
    },


    fnIsActive(piPage)
    {
      
      let wret=false;

      if (window.location.pathname=="/")
      {
          if (piPage=="home")
          {
            wret=true;
          }
      }
      else
      {
        if (window.location.pathname.length>=4)
        {
          if ((window.location.pathname[0]=="/") && (window.location.pathname[3]=="/"))
          {
              if (window.location.pathname.substring(4,window.location.pathname.length).toLowerCase()==piPage)
              {
                wret=true;
              }
          }
        }
      }

      //console.log(piPage,wret,window.location.pathname);

      return wret;
    },
      



    fnFillMenu(){

        this.menus=[];

        let i=0;
        for(i=0;i<this.pages.length;i++)
        {
            this.menus.push({"label": this.fnGetTranslation(this.currentlang,this.pages[i]), "link": "/" +this.currentlang+"/"+this.pages[i],"isactive": this.fnIsActive(this.pages[i])})  
        }


    }


  }

  

}


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
   
.mainmenu{
    background-image: url("~@/assets/images/logo.svg");
    background-position: 20px 10px;
    background-repeat: no-repeat;
    background-size: 170px;
    overflow: auto;

}

  .topnav {
    overflow: hidden;
    background-color: transparent;
    float: right;
    padding-top: 20px;
    padding-right: 30px;

  

  }
  
  .topnav a {
    float: left;
    display: block;
    color: #080808;
    text-align: center;
    padding: 14px 16px;
    text-decoration: none;
    font-size: 0.8em;
    font-weight: bold;
  }
  
  .topnav a:hover {
    background-color: transparent;
    color: black;
  }
  
  .topnav a.active {
    background-color: transparent;
    color: #080808;
    border-bottom: #ffdd00;
    text-decoration: underline;
    text-decoration-style: solid;
    text-decoration-color: #ffdd00;
    text-decoration-thickness: 0.3em;
       
        
  }
  
  .topnav .icon {
    display: none;
  }
  






  @media screen and (min-width: 870px)    {
      /*  schermo desktop */
    

      .mainmenu{
        /*max-width: 1200px;*/
        margin-left: auto;
        margin-right: auto;
        min-height: 90px;

        
      }


  }
  
  @media screen and (max-width: 870px) {
     /*  schermo mobile */
  

     .mainmenu{
      min-height: 90px;

    }


     .topnav a 
    {
        display: none;
        font-size: 1em;
    }
    
    .topnav a.icon 
    {
      float: right;
      display: block;
    }
    
     
    .topnav.responsive 
    {
        background-color: #ffdd00;
        position: relative;
    }
    
    .topnav.responsive .icon 
    {
      position: absolute;
      right: 0;
      top: 0;
    }
    
    .topnav.responsive a 
    {
      float: none;
      display: block;
      text-align: left;
    }


  }







</style>
